module.exports = __webpack_public_path__ + "static/img/rank_background.21a398da.png";